import { FFormChildMDP } from "@/components/form/FFormMDP";
import FDataTableMDP from "@/components/table/FDataTableMDP";



export default class CreditorSummaryFDataTableMDP extends FDataTableMDP {
    childMDP = new FFormChildMDP();
    constructor(props: {taskRoot: any}) {
        super({
            dataSelectorKey: "creditorList",
            myRefName:"creditorSummaryFDataTableRef"
        });
        this.addColumn({
            label: "Creditor Name1",
            dataSelectorKey:"creditorName"
        }).addColumn({
            label: "Type",
            dataSelectorKey:"debtType"
        }).addColumn({
            label: "Outstanding Amount",
            dataSelectorKey:"creditorBalance"
        }).addColumn({
            label: "Delinquency(at Enrolment)",
            dataSelectorKey:"daysDelinquentAsOnOnboarding"
        })
        .addInfo({
            label:`WAD`,
            value:`${props.taskRoot.clientFileBasicInfo.wad}`
        })
        
        ;
    }

}